import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { REMINDER_QUERY_KEYS } from './keys';

import * as reminderService from 'services/reminder';

import type { ServiceId, ServiceParams } from 'interface/service';
import type { Reminder } from 'interface/reminders';

type ReminderListResponse = { data?: Reminder[] };

export const getRemindersQueryKey = (params: ServiceParams = {}) => [REMINDER_QUERY_KEYS.LIST, params] as const;

export const remindersQueryOptions = (params: ServiceParams = {}) => ({
  queryKey: getRemindersQueryKey(params),
  queryFn: () => reminderService.fetchAll(params) as Promise<ReminderListResponse>,
});

export const useFetchRemindersQuery = (
  params: ServiceParams = {},
  enabled = true
): UseQueryResult<ReminderListResponse, Error> => {
  return useQuery({
    ...remindersQueryOptions(params),
    enabled,
  });
};

export const getReminderByIdQueryKey = (id?: ServiceId) => [REMINDER_QUERY_KEYS.DETAIL, id] as const;

export const useFetchReminderByIdQuery = <TData = Reminder>(
  id?: ServiceId,
  enabled = true
): UseQueryResult<TData, Error> => {
  return useQuery({
    queryKey: getReminderByIdQueryKey(id),
    queryFn: () => reminderService.fetchReminder(id!) as Promise<TData>,
    enabled: Boolean(id) && enabled,
  });
};
